module.exports = __webpack_public_path__ + "media/images/hr/logo-vendor-5640cbf67708a683d7a14aea066ffdbf.svg";